import EmojiEmotionsIcon from '@mui/icons-material/EmojiEmotions';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import Clock from "../clock/clock";


export const iconStyle = {
    fontSize: 15,
    marginTop: 0.5,
}

export const AIBHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 44,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: true,
        type: 'video',
        isUp: false,
        width: 250,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Transcript',
        subtitle: 'by sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 400,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Seconds',
        subtitle: 'of duration',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'length',
        title: 'Length',
        subtitle: 'of characters',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'categories',
        title: 'Categories',
        sort: false,
        filter: true,
        type: 'listCategory',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: true,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },
]

export const categoriesHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 44,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: true,
        type: 'video',
        isUp: false,
        width: 250,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Transcript',
        subtitle: 'by sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 400,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'categories',
        title: 'Categories',
        sort: false,
        filter: true,
        type: 'listCategory',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Seconds',
        subtitle: 'of duration',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'length',
        title: 'Length',
        subtitle: 'of characters',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        // Hidden until the AI virality pass runs; shows the score badge on each category chunk.
        visible: false,
        field: 'virality_score',
        title: 'Viral',
        subtitle: 'AI score',
        sort: true,
        filter: false,
        type: 'number',
        isUp: false,
        width: 56,
        value: false,
        restore: false,
        align: 'center'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: true,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },
]

export const autoHighlightHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 44,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 200,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentence',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Seconds',
        subtitle: 'of duration',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'length',
        title: 'Length',
        subtitle: 'of characters',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'rank',
        title: 'Rank',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: true,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    },

]

export const contentModerationHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 44,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 200,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Sentence',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'label',
        title: 'Label',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Seconds',
        subtitle: 'of duration',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'length',
        title: 'Length',
        subtitle: 'of characters',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: true,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    }

]
export const entitiesHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 44,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'right'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 200,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sentence',
        title: 'Transcript',
        subtitle: 'by sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'entity_type',
        title: 'Type',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Seconds',
        subtitle: 'of duration',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'length',
        title: 'Length',
        subtitle: 'of characters',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: true,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 40,
        value: false,
        restore: false,
        align: 'right'
    }


]

export const sentencesHeader = [

    {
        visible: true,
        field: '',
        title: '',
        sort: false,
        filter: false,
        type: 'checkbox',
        isUp: false,
        width: 44,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'order',
        title: '',
        sort: false,
        filter: false,
        type: 'number',
        isUp: false,
        width: 30,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'speaker',
        title: 'Spkr',
        sort: true,
        filter: true,
        type: 'icon',
        isUp: false,
        width: 60,
        value: false,
        restore: false,
        align: 'center'
    },
    {
        visible: true,
        field: 'sentiment',
        title: 'Emo',
        subtitle: 'Emotion',
        sort: false,
        filter: true,
        type: 'string',
        isUp: false,
        width: 35,
        value: true,
        restore: false,
        align: 'left'
    },

    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: true,
        type: 'video',
        isUp: false,
        width: 300,
        value: false,
        restore: false,
        align: 'left'
    },


    {
        visible: true,
        field: 'sentence',
        title: 'Transcript',
        subtitle: 'by sentences',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 250,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'sec',
        title: 'Seconds',
        subtitle: 'of duration',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'length',
        title: 'Length',
        subtitle: 'of characters',
        sort: true,
        filter: true,
        type: 'number',
        isUp: false,
        width: 70,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'question',
        title: 'Q?',
        subtitle: 'Questions',
        sort: true,
        filter: true,
        type: 'boolean',
        isUp: false,
        width: 22,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        // Hidden until the user runs the AI virality score; then it replaces the Q? column.
        visible: false,
        field: 'virality_score',
        title: 'Viral',
        subtitle: 'AI score',
        sort: true,
        filter: false,
        type: 'number',
        isUp: false,
        width: 56,
        value: false,
        restore: false,
        align: 'center'
    },
    {
        visible: false,
        field: 'contains_numbers',
        title: '#',
        subtitle: 'Numbers',
        sort: true,
        filter: true,
        type: 'boolean',
        isUp: false,
        width: 50,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'verbs',
        title: 'Actions',
        subtitle: 'Verbs',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 42,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'adjectives',
        title: 'Descriptions',
        subtitle: 'Adjectives',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 42,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'nouns',
        title: 'Things',
        subtitle: 'Nouns',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 46,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: false,
        field: 'entities_text',
        title: 'Entities',
        subtitle: 'People · Places · Orgs',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 80,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: false,
        field: 'highlights_text',
        title: 'Highlights',
        subtitle: 'Key phrases',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 80,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: false,
        field: 'content_mod_labels',
        title: 'Flags',
        subtitle: 'Content safety',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: 60,
        value: false,
        restore: false,
        align: 'left'
    },
    // ── Media Detection (column set: 'media') ───────────────────────────────
    { visible: false, field: 'sound_effects',    title: 'Sound',    subtitle: 'Effects',       sort: false, filter: false, type: 'string', isUp: false, width: 80,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'visuals_detected', title: 'Visuals',  subtitle: 'Detected',      sort: false, filter: false, type: 'string', isUp: false, width: 80,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'camera_shot',      title: 'Camera',   subtitle: 'Shot',          sort: false, filter: false, type: 'string', isUp: false, width: 80,  value: false, restore: false, align: 'left' },
    // ── Chachma Bina Daas (column set: 'cbd') ────────────────────────────────
    { visible: false, field: 'chachma',          title: 'Chachma',  subtitle: 'Wisdom',        sort: false, filter: false, type: 'string', isUp: false, width: 90,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'bina',             title: 'Bina',     subtitle: 'Understanding', sort: false, filter: false, type: 'string', isUp: false, width: 90,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'daas',             title: 'Daas',     subtitle: 'Knowledge',     sort: false, filter: false, type: 'string', isUp: false, width: 90,  value: false, restore: false, align: 'left' },
    // ── Avraham Yitzchak Yaakov (column set: 'ayy') ──────────────────────────
    { visible: false, field: 'avraham',          title: 'Avraham',  subtitle: 'Chesed',        sort: false, filter: false, type: 'string', isUp: false, width: 90,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'yitzchak',         title: 'Yitzchak', subtitle: 'Gevura',        sort: false, filter: false, type: 'string', isUp: false, width: 90,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'yaakov',           title: 'Yaakov',   subtitle: 'Tiferet',       sort: false, filter: false, type: 'string', isUp: false, width: 90,  value: false, restore: false, align: 'left' },
    // ── Three Pillars (column set: 'pillars') ────────────────────────────────
    { visible: false, field: 'torah',            title: 'Torah',    subtitle: 'Learning',      sort: false, filter: false, type: 'string', isUp: false, width: 80,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'avoda',            title: 'Avoda',    subtitle: 'Service',       sort: false, filter: false, type: 'string', isUp: false, width: 80,  value: false, restore: false, align: 'left' },
    { visible: false, field: 'gimilat_hasidim',  title: 'Gimilat',  subtitle: 'Hasidim',       sort: false, filter: false, type: 'string', isUp: false, width: 100, value: false, restore: false, align: 'left' },
    {
        visible: false,
        field: 'start',
        title: 'Start',
        sort: true,
        filter: true,
        type: 'time',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: false,
        field: 'stop',
        title: 'Stop',
        sort: true,
        filter: true,
        type: 'time',
        isUp: false,
        width: 100,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration',
        title: <Clock />,
        sort: true,
        filter: false,
        type: 'icon',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'right'
    },
]

export const downloadedHeader = [
    {
        visible: true,
        field: '',
        title: '',
        sort: true,
        filter: false,
        type: 'none',
        isUp: false,
        width: '5%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'title',
        title: 'Title',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: '25%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: '300',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'task_status',
        title: 'Task',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: '10%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'downloaded',
        title: 'Downloaded',
        sort: true,
        filter: true,
        type: 'dateTime',
        isUp: false,
        width: '15',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'delete',
        title: 'Delete',
        sort: false,
        filter: false,
        type: 'button',
        isUp: false,
        width: '10%',
        value: false,
        restore: false,
        align: 'center'
    },

]

export const transcriptsHeader = [
    {
        visible: true,
        field: 'title',
        title: 'Title',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: '18%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'play',
        title: '',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: '30%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'transcription_engine',
        title: 'Engine',
        sort: true,
        filter: false,
        type: 'string',
        isUp: false,
        width: '10%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'duration_in_seconds',
        title: 'Duration',
        sort: true,
        filter: false,
        type: 'duration',
        isUp: false,
        width: '8%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'task_status',
        title: 'Status',
        sort: true,
        filter: true,
        type: 'string',
        isUp: false,
        width: '10%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'created_at',
        title: 'Created',
        sort: true,
        filter: true,
        type: 'dateTime',
        isUp: false,
        width: '14%',
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'create_video',
        title: 'Create Video',
        sort: false,
        filter: false,
        type: 'button',
        isUp: false,
        width: '8%',
        value: false,
        restore: false,
        align: 'center'
    },
    {
        visible: true,
        field: 'run_whisper',
        title: 'Run Whisper',
        sort: false,
        filter: false,
        type: 'button',
        isUp: false,
        width: '8%',
        value: false,
        restore: false,
        align: 'center'
    },
    {
        visible: true,
        field: 'delete',
        title: 'Delete',
        sort: false,
        filter: false,
        type: 'button',
        isUp: false,
        width: '5%',
        value: false,
        restore: false,
        align: 'center'
    },
]

export const myCreationHeader = [

    {
        visible: true,
        field: 'title',
        title: 'Title',
        sort: true,
        filter: false,
        type: 'string',
        isUp: false,
        width: 180,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'description',
        title: 'Description',
        sort: true,
        filter: false,
        type: 'description',
        isUp: false,
        width: 180,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'video',
        title: '',
        sort: false,
        filter: false,
        type: 'video',
        isUp: false,
        width: 350,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'download',
        title: 'Download',
        sort: false,
        filter: false,
        type: 'download',
        isUp: false,
        width: 80,
        value: false,
        restore: false,
        align: 'center'
    },

    {
        visible: true,
        field: 'type',
        title: 'Type',
        sort: true,
        filter: false,
        type: 'string',
        isUp: false,
        width: 80,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'created',
        title: 'Created',
        sort: true,
        filter: false,
        type: 'date',
        isUp: false,
        width: 150,
        value: false,
        restore: false,
        align: 'left'
    },
    {
        visible: true,
        field: 'delete',
        title: 'Delete',
        sort: false,
        filter: false,
        type: 'button',
        isUp: false,
        width: '10%',
        value: false,
        restore: false,
        align: 'center'
    },



]


